import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { GeofencesService } from "../../services/Geofences.service";
import { MapHelperService } from "src/services/map-helper.service";
import { TutorialService } from "src/app/features/shared/features/tutorial/services/tutorial.service";
import { EstatusJSON } from "src/app/features/shared/models/EstatusJSON";
import { MapService } from "src/app/features/shared/services/Map.service";
import { SessionService } from "src/app/features/shared/services/Session.service";

@Component({
  selector: "geofences-map",
  templateUrl: "./geofences-map.component.html",
  styleUrls: ["./geofences-map.component.css"],
})
export class GeofencesMapComponent implements OnInit, OnDestroy {
  public isLoading: boolean = true;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  public IsAuthenticated = false;
  public _isVisiblePinbar: boolean;
  public _isVisibleNavBar: boolean;
  public _isVisiblePanelGeofences: boolean;
  public _isVisiblePanelEditGeofences: boolean;
  public _isVisiblePanelDetailGeofences: boolean;
  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";
  dataGeoJsonLocations: any;
  private $isVisiblePanelGeofences: Observable<boolean>;
  private $isVisiblePanelEditGeofences: Observable<boolean>;
  private $isVisiblePanelDetailGeofences: Observable<boolean>;
  subscription_GetLoading: Subscription;
  subscription_SetLocationsGeoJson: Subscription;
  subscription_checkAuthenticated: Subscription;
  isVisiblePanelGeofences: Subscription;
  isVisiblePanelAddGeofences: Subscription;
  isVisiblePanelEditGeofences: Subscription;
  isVisiblePanelDetailGeofences: Subscription;
  isAdmin: any;
  isMapUnified: boolean;

  constructor(
    private mapService: MapService,
    private geofencesService: GeofencesService,
    private sessionService: SessionService,
    private mapHelperService: MapHelperService,
    private tutorialService: TutorialService
  ) {
    this.$isVisiblePanelGeofences = this.geofencesService.getVisiblePanelGeofences();
    this.isVisiblePanelGeofences = this.$isVisiblePanelGeofences.subscribe((data) => {
      this._isVisiblePanelGeofences = data;
      setTimeout(() => {
        if (this._isVisiblePanelGeofences != undefined && this._isVisiblePanelGeofences == true) {
          this.tutorialService.startTutorial(["panelGeofencesTutorial"]);
        }
      }, 1000);
    });

    this.$isVisiblePanelEditGeofences = this.geofencesService.getVisiblePanelEditGeofences();
    this.isVisiblePanelEditGeofences = this.$isVisiblePanelEditGeofences.subscribe((data) => {
      this._isVisiblePanelEditGeofences = data;
    });

    this.$isVisiblePanelDetailGeofences = this.geofencesService.getVisiblePanelDetailGeofences();
    this.isVisiblePanelDetailGeofences = this.$isVisiblePanelDetailGeofences.subscribe((data) => {
      this._isVisiblePanelDetailGeofences = data;
      setTimeout(() => {
        if (this._isVisiblePanelDetailGeofences != undefined && this._isVisiblePanelDetailGeofences == true) {
          this.tutorialService.startTutorial(["panelGeofenceDetailTutorial"]);
        }
      }, 1000);
    });
    this.geofencesService.setVisiblePanelDetailGeofences(false);
    this.isMapUnified = false;
  }

  ngOnInit(): void {
    this.CheckingSourceURL();
    this.StartMap();

    this.subscription_GetLoading = this.geofencesService
      .getLoading()
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });
    this._isVisiblePinbar = true;
  }

  ngOnDestroy() {
    if (this.subscription_SetLocationsGeoJson)
      this.subscription_SetLocationsGeoJson.unsubscribe();
    if (this.subscription_GetLoading)
      this.subscription_GetLoading.unsubscribe();
    if (this.subscription_checkAuthenticated)
      this.subscription_checkAuthenticated.unsubscribe();
    if (this.isVisiblePanelGeofences)
      this.isVisiblePanelGeofences.unsubscribe();
    if (this.isVisiblePanelAddGeofences)
      this.isVisiblePanelAddGeofences.unsubscribe();
    if (this.isVisiblePanelEditGeofences)
      this.isVisiblePanelEditGeofences.unsubscribe();
    if (this.isVisiblePanelDetailGeofences)
      this.isVisiblePanelDetailGeofences.unsubscribe();
  }

  // GetLocations() {
  //   console.log("GetLayerGPSGeoJson");
  //   setTimeout(() => {
  //     this.subscription_SetLocationsGeoJson = this.locationsService
  //       .GetLayerGPSGeoJson()
  //       .subscribe((data: EstatusJSON) => {
  //         if (data.isSuccess == true) {
  //           this.dataGeoJsonLocations = JSON.parse(data.result);
  //           console.log("UPDATING LAYER...", this.dataGeoJsonLocations);
  //           this.MapHelper.UpdateLayerGeoJson(
  //             "locationsSource",
  //             this.dataGeoJsonLocations
  //           );
  //         }
  //       });
  //   }, 1500);
  // }

  

  CheckingSourceURL() {
    this.sessionService.CheckURLSource();
    this._isVisibleNavBar = this.sessionService.isMapix;
  }

  StartMap() {
    this._isVisiblePinbar = true;
    this._isVisiblePanelGeofences = false;
    this._isVisiblePanelEditGeofences = false;
    this._isVisiblePanelDetailGeofences = false;
    this.mapService.LoadMapGeofences();
  }
}
